import { render, staticRenderFns } from "./FeaturedCollectionsGroup.vue?vue&type=template&id=40fcfc15&scoped=true&"
import script from "./FeaturedCollectionsGroup.vue?vue&type=script&lang=js&"
export * from "./FeaturedCollectionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCollectionsGroup.vue?vue&type=style&index=0&id=40fcfc15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fcfc15",
  null
  
)

export default component.exports